import { Injectable, Type } from "@angular/core";

import { BaseLookupService } from "./BaseLookupService";

import { IPromiseLookupService } from "../IPromiseLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class PromiseLookupService<K, V extends CubiqTS.ConcreteEncodable>
  implements IPromiseLookupService<K, V>
{
  protected lookupType: Type<CubiqTS.ConcreteEncodable> | Array<Type<CubiqTS.ConcreteEncodable>>;
  protected serviceChannel: string;

  /**
   * As we can't assume location of Primary
   * (e.g. different worker, even UI)
   */
  constructor() {}

  abstract isPrimed(): Promise<boolean>;
  abstract prime(values: Array<V>): Promise<void>;
  abstract getItemKey(item: V): Promise<K>;
  abstract getItem(id: K): Promise<V>;
  abstract createItem(item: V): Promise<boolean>;
  abstract updateItem(item: V): Promise<boolean>;
  abstract deleteItem(item: V): Promise<void>;
  abstract deleteItemById(id: K): Promise<void>;
  abstract getAll(): Promise<Array<V>>;
  // abstract mapItem(item:any): Promise<void>;
  abstract getBase(): any;
  abstract getModelUpdateSubject(): Subject<CubiqTS.ConcreteEncodable>;
  abstract lookupItem(propertyName: string, substring: string): Promise<Array<V>>;
}
